export default function (element, data) {
    let prevScrollPos = window.scrollY;
    function update(scrollPos) {
        if (scrollPos > 60 && scrollPos > prevScrollPos) {
            element.classList.add("hide-mobile-menu");
            element.classList.remove("show-mobile-menu");
        } else {
            element.classList.remove("hide-mobile-menu");
            element.classList.add("show-mobile-menu");
        }
    }

    window.addEventListener('scroll', function () {
        const scrollPos = window.scrollY;

        if (Math.abs(scrollPos - prevScrollPos) > 40) {
            update(scrollPos);
            prevScrollPos = scrollPos;
        }
    }, {
        passive: true
    });

    setTimeout(function () { update(prevScrollPos); }, 500);
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary